import { render, staticRenderFns } from "./PartsEdit.vue?vue&type=template&id=3b28f0ae&"
import script from "./PartsEdit.vue?vue&type=script&lang=js&"
export * from "./PartsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports